import React from 'react';
import { Checkbox } from '@groupelacentrale/contact-storybook';
import { config } from 'config';

interface Props {
  checked: boolean;
  hasError?: boolean;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void | undefined;
}

export const TermsOfService: React.FC<Props> = props => {
  return (
    <Checkbox
      theme="primary"
      label={
        <>
          J&apos;ai lu et j&apos;accepte les&nbsp;
          <a
            href={`${config.URL_LACENTRALE}informations/conditions-generales`}
            rel="noopener noreferrer"
            target="_blank"
          >
            conditions générales
          </a>
          &nbsp;de la Centrale ainsi que la&nbsp;
          <a
            href={`${config.URL_LACENTRALE}informations/politique-confidentialite`}
            rel="noopener noreferrer"
            target="_blank"
          >
            politique de confidentialité
          </a>
          &nbsp;et la&nbsp;
          <a href={`${config.URL_LACENTRALE}informations/charte-cookies`} rel="noopener noreferrer" target="_blank">
            charte cookies
          </a>
          .
        </>
      }
      {...props}
    />
  );
};
